import React from "react";

export default function Loading() {
    return (
        <div className="overlay" style={{ zIndex: 999999999 }}>
            <div className="overlay__inner">
                <div className="overlay__content"><span className="spinner"></span></div>
            </div>
        </div>
    );
}


